/**
 * The public content families: every URL prefix whose pages exist to answer a
 * search query rather than to run the product. Web reads this to keep
 * product-only behaviour (the session pricing modal, S6) off those pages, so a
 * family added here is covered everywhere at once. A public web route outside
 * these must be declared a product surface, or
 * web/tests/unit/seoRegistryCoverage.test.ts fails.
 */
export const CONTENT_PATH_PREFIXES = [
  '/tools',
  '/guides',
  '/glossary',
  '/blog',
  '/room-modes',
  '/materials',
  '/absorption-coefficients',
  '/case-studies',
  '/gear',
  '/authors',
  '/about',
  '/methodology',
  '/editorial-policy',
  '/contact',
  '/privacy',
  '/terms',
  '/disclosure',
] as const;

/** True when `pathname` is a content prefix or lies beneath one. Matches on a
 *  segment boundary: `/tools` and `/tools/x` are content, `/toolsx` is not. */
export function isContentPath(pathname: string): boolean {
  return CONTENT_PATH_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}
